import { useMutation } from '@tanstack/react-query';

import { reachoutClient } from 'clients/ReachoutClient/ReachoutClient';
import { QueryKey } from 'types/query';

export const useGenerateEnrichedVersionMutation = () => {
  return useMutation({
    mutationKey: [QueryKey.useGenerateEnrichedVersionMutation],
    mutationFn: async (jobPreview: string) => {
      const { data: response } = await reachoutClient.generateEnrichedVersion({ job_preview: jobPreview });

      return response;
    },
  });
};
